import MenuNavigator from '../components/modules/menuNavigator';

const menuNavigator = [
  {
    path: '/menu-navigator',
    name: 'MenuNavigator',
    component: MenuNavigator,
    meta: {
      title: 'MenuNavigator',
    },
  },
];
export default menuNavigator;
